import React, { Component, Fragment, useState, useEffect } from "react";
import classnames from "classnames";
import { Link, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  AppBar,
  BottomNavigation,
  BottomNavigationAction,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  DialogActions,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  Hidden,
  IconButton,
  withMobileDialog,
} from "@material-ui/core";
import Info from "@material-ui/icons/Info";
import Close from "@material-ui/icons/Close";
import ContactUs from "./ContactUs";
import Create from "@material-ui/icons/Create";
import MenuIcon from "@material-ui/icons/Menu";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { Person, Work } from "@material-ui/icons";
import SelectProduct from "./Forms";
import { ewbConfig } from "../config";
import styles from "style";
import SideBar from "./Navigators/SideBar";
import NavBarLeftSection from "./Navigators/NavBarLeftSection";
import NavBarRightSection from "./Navigators/NavBarRightSection";
import Footer from "./Footer";
import Sitemap from "./Sitemap";
import SitemapBusiness from "./SitemapBusiness";
import withPathListener from "hoc/withPathListener";
import { FOREX_RATES_STAND_ALONE_PATH } from "routes/paths";

function AlertDialog() {
  const [open, setOpen] = React.useState(false);
  const [annoucementData, setAnnoucementData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(ewbConfig.apiUrl + "annoucement");
        const json = await res.json();
        if (json.length > 0) {
          setAnnoucementData(json);
          setIsLoading(false);
          setOpen(true);
        }
      } catch (error) {
        console.log("error", error);
      }
    }
    fetchData();
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography color="secondary" variant="h6">
            {annoucementData[0].title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            dangerouslySetInnerHTML={{ __html: annoucementData[0].body }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            X CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir}>
      {children}
    </Typography>
  );
}

class FabButton extends Component {
  state = {
    open: false,
    value: 0,
    confirm: false,
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    switch (this.state.value) {
      case 0:
        this.setState({
          confirm: true,
        });
        break;
      case 1:
        this.setState({
          open: false,
        });
        break;
      default:
    }
  };

  handleChange = (event, value) => {
    document.getElementById("fab-modal").scrollTo(0, 0);
    this.setState({
      value,
    });
  };

  handleChangeIndex = (index) => {
    this.setState({
      value: index,
    });
  };

  handleConfirmOpen = () => {
    this.setState({ confirm: true });
  };
  handleConfirmAgree = () => {
    this.setState({
      confirm: false,
    });
  };
  handleConfirmClose = () => {
    this.setState({
      confirm: false,
      open: false,
    });
  };
  handleThankYou = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const {
      classes,
      theme,
      productType,
      fabExecution,
      fullScreen,
      cta,
      id,
      formtype,
      formval,
    } = this.props;

    if (!id) {
      return <span />;
    }

    return (
      <Fragment>
        {fabExecution === "circle" ? (
          <Button
            size="large"
            color="primary"
            variant="contained"
            className={classnames(classes.fabButton, "trackme")}
            id={id.replace(/\s+/g, "")}
            aria-label="Delete"
            onClick={this.handleClickOpen}
          >
            Apply Now
          </Button>
        ) : (
          <Button
            size="medium"
            color="secondary"
            variant="contained"
            onClick={this.handleClickOpen}
            className={classnames(classes.fabButton, "trackme")}
            id={id.replace(/\s+/g, "")}
          >
            {cta === undefined ? <strong>APPLY NOW</strong> : <>{cta}</>}
          </Button>
        )}

        <Dialog
          fullScreen={fullScreen}
          name={this.state.selectedValue}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <AppBar className={classes.appbar} position="static" color="default">
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              textColor="secondary"
              classes={{ root: classes.tabsRoot }}
              indicatorColor="primary"
              variant="fullWidth"
            >
              <Tab classes={{ fullWidth: classes.fullWidth }} label="APPLY" />
              <Tab
                classes={{ fullWidth: classes.fullWidth }}
                label="CONTACT US"
              />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={this.state.value}
            onChangeIndex={this.handleChangeIndex}
            id="fab-modal"
          >
            <TabContainer dir={theme.direction}>
              <SelectProduct
                handleClose={this.handleThankYou}
                productType={productType}
                formtype={formtype}
                formval={formval}
                displayType="desktop"
              />
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <ContactUs />
            </TabContainer>
          </SwipeableViews>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {/* // ------------------ confirmation message */}
        <Dialog
          open={this.state.confirm}
          onClose={this.handleConfirmationClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to close?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleConfirmAgree} color="primary" autoFocus>
              No
            </Button>
            <Button onClick={this.handleConfirmClose} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

export const RenderFabButton = withMobileDialog()(
  withStyles(styles, {
    withTheme: true,
  })(FabButton)
);

class Navigation extends Component {
  state = {
    cookies: true,
    isOpen: false,
    navigationvalue: 0,
    pathname: "",
  };

  componentDidMount() {
    this.unlisten = this.props.history.listen((location) => {
      this.setState({ ...this.state, pathname: location.pathname });
    });
  }
  toggleDrawer = (nav, open) => () => {
    this.setState({
      isOpen: open,
    });
    if (nav === null) {
      window.scrollTo(0, 0);
      return;
    }
  };
  toggleDrawer1 = (open) => () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handleBottomNav = (event, value) => {
    this.setState({
      value,
    });
    if (value < 3) {
      window.scrollTo(0, 0);
    }
    if (window.innerWidth < 960 && this.state.isOpen === "open") {
      document.body.classList.add("overlay-active");
    } else {
      document.body.classList.remove("overlay-active");
    }
  };

  handleCookieClose = (event, reason) => {
    this.setState({ cookies: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Hidden mdUp>
          {/* mobile */}
          <Drawer
            anchor="right"
            open={this.state.isOpen}
            onClose={this.toggleDrawer(null, false)}
            variant="temporary"
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <SideBar onItemClick={this.toggleDrawer("nav", false)} />
            <Footer />
          </Drawer>
        </Hidden>
        <Hidden smDown>
          <Drawer
            anchor="left"
            open={this.state.isOpen}
            onClose={this.toggleDrawer(null, false)}
            variant="temporary"
          >
            <SideBar onItemClick={this.toggleDrawer("nav", false)} />
          </Drawer>
        </Hidden>
        <div className={classes.root}>
          <AppBar
            className={classes.appBar}
            position="fixed"
            style={{
              visibility:
                this.props.path === FOREX_RATES_STAND_ALONE_PATH
                  ? "hidden"
                  : "visible",
            }}
          >
            <Toolbar>
              <Hidden smDown>
                <IconButton
                  className={classes.menuButton}
                  onClick={this.toggleDrawer("nav", true)}
                  color="inherit"
                  aria-label="Menu"
                >
                  <MenuIcon color="primary" />
                </IconButton>
              </Hidden>

              <NavBarLeftSection />
              <NavBarRightSection />
            </Toolbar>
          </AppBar>

          <article
            className={classes.mainContent}
            onClick={this.toggleDrawer("nav", false)}
          >
            <div className={classes.toolbar} />
            {this.props.children}
            <Hidden smDown>
              {/* SITEMAP */}
              <div
                style={{
                  visibility:
                    this.props.path === FOREX_RATES_STAND_ALONE_PATH
                      ? "hidden"
                      : "visible",
                }}
              >
                {window.location.pathname.split("/")[1] == "business" ? (
                  <SitemapBusiness />
                ) : (
                  <Sitemap />
                )}
                <hr
                  style={{
                    width: "80%",
                    margin: "30px auto",
                  }}
                />
                <Footer />{" "}
              </div>
            </Hidden>
          </article>

          {/* MOBILE BOTTOM NAV */}
          <Hidden mdUp>
            <BottomNavigation
              value={this.state.bottomNavigation}
              onChange={this.handleBottomNav}
              showLabels
              className={classes.bottomNavigation}
              style={{
                visibility:
                  this.props.path === FOREX_RATES_STAND_ALONE_PATH
                    ? "hidden"
                    : "visible",
              }}
            >
              <BottomNavigationAction
                component={Link}
                to="/"
                label="Personal"
                icon={<Person />}
                onClick={this.toggleDrawer(null, false)}
              />
              <BottomNavigationAction
                component={Link}
                to="/business"
                label="Business"
                icon={<Work />}
                onClick={this.toggleDrawer(null, false)}
              />
              <BottomNavigationAction
                component={Link}
                to="/Contactus"
                label="Contact"
                icon={<Info />}
                onClick={this.toggleDrawer(null, false)}
              />
              <BottomNavigationAction
                component={Link}
                to="/Forms"
                label="Apply"
                icon={<Create />}
                onClick={this.toggleDrawer(null, false)}
              />
              <BottomNavigationAction
                label="Menu"
                icon={this.state.isOpen === false ? <MenuIcon /> : <Close />}
                onClick={this.toggleDrawer1(true)}
              />
            </BottomNavigation>
          </Hidden>

          <AlertDialog />
        </div>
      </div>
    );
  }
}

Navigation.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withPathListener(
  withRouter(
    withStyles(styles, {
      withTheme: true,
    })(Navigation)
  )
);
